exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".card[data-v-66bd8d2a]{min-height:140px}svg[data-v-66bd8d2a]{max-width:100px}", ""]);

